import * as RT from '@radix-ui/react-tooltip'
import { type ReactNode, forwardRef } from 'react'
import { cn } from '../lib/cn'

export const TooltipProvider = RT.Provider

export interface TooltipProps {
  content: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  delay?: number
  children: ReactNode
  className?: string
}

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(
  { content, side = 'top', delay = 200, children, className },
  _ref,
) {
  if (!content) return <>{children}</>
  return (
    <RT.Root delayDuration={delay}>
      <RT.Trigger asChild>{children as never}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          side={side}
          sideOffset={6}
          className={cn(
            'z-50 rounded-md border border-[var(--hostingportal-border)] bg-[var(--hostingportal-surface-raised)]',
            'px-2 py-1 text-xs text-[var(--hostingportal-fg)] shadow-[var(--hostingportal-shadow-floating)]',
            'data-[state=delayed-open]:animate-in data-[state=closed]:animate-out fade-in-0 fade-out-0',
            className,
          )}
        >
          {content}
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  )
})
